// Keep a referral code through the public website without storing attribution.
// Consent and validation happen in registration, exclusively on the server.
export function softwareRegistrationHref(plan = 'growth', search = '') {
  const params = new URLSearchParams({ plan, billing_period: 'yearly' });
  const partner = new URLSearchParams(search).get('partner');
  if (partner) params.set('partner', partner);
  return `/register?${params.toString()}`;
}

// Public navigation keeps only the referral code, never checkout/session data.
export function softwareWebsiteHref(path, search = '') {
  const [pathname, hash] = path.split('#');
  const partner = new URLSearchParams(search).get('partner');
  const query = partner ? `?${new URLSearchParams({ partner }).toString()}` : '';
  return `${pathname}${query}${hash ? `#${hash}` : ''}`;
}
